// extracted by mini-css-extract-plugin
module.exports = {"passageTest":"PassageTest_passageTest__2O5U7","passage":"PassageTest_passage__aqbAA","question":"PassageTest_question__3Kn3m"};